module.exports = __webpack_public_path__ + "static/media/pointcard.ceb1ca97.png";